import api from './client';

export const journalApi = {
  list:    (params?: any) => api.get('/journals', { params }),
  get:     (id: number)   => api.get(`/journals/${id}`),
  post:    (data: any)    => api.post('/journals', data),
  update:  (id: number, data: any) => api.put(`/journals/${id}`, data),
  reverse: (id: number)   => api.post(`/journals/${id}/reverse`, {}),
};
